import axios from 'axios';
import config from '../config/config';
import {
    TRANSLATION_RECEIVE_TRANSLATIONS,
    TRANSLATION_FILTER_BY_SEARCH_STRING,
    TRANSLATION_DIALOG_ADD_TRANSLATION,
    TRANSLATION_DIALOG_EDIT_TRANSLATION,
    TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION,
    TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION,
    TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR,
    TRANSLATION_SEND_ADD_EDIT_TRANSLATION,
    TRANSLATION_RECEIVE_DELETE_TRANSLATION
} from '../config/actions';

export function getTranslations(setAllVisible) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/translation', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch(receiveTranslations(response.data, setAllVisible));
            }
        })
    }
}

export function receiveTranslations(data, setAllVisible) {
    return {
        type: TRANSLATION_RECEIVE_TRANSLATIONS,
        data,
        setAllVisible
    }
}

export function filterTranslationsBySearchString(searchString) {
    return {
        type: TRANSLATION_FILTER_BY_SEARCH_STRING,
        searchString
    }
}

export function openDialogAddTranslation() {
    return {
        type: TRANSLATION_DIALOG_ADD_TRANSLATION
    }
}

export function openDialogEditTranslation(id, key, de, en, translationType) {
    return {
        type: TRANSLATION_DIALOG_EDIT_TRANSLATION,
        id: id,
        key: key,
        de: de,
        en: en,
        translationType: translationType
    }
}

export function deleteTranslation(id) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/translation', {
            method: 'delete',
            data: {
                translation: id
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(receiveDeleteTranslation());
                    dispatch(getTranslations(true));
                }
            }
        })
    }
}

export function receiveDeleteTranslation() {
    return {
        type: TRANSLATION_RECEIVE_DELETE_TRANSLATION
    }
}

export function cancelAddEditTranslations() {
    return {
        type: TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION
    }
}

export function submitAddEditTranslation(translationId, key, de, en, translationType) {
    return dispatch => {
        dispatch(sendAddEditTranslation());
        axios(config.server.endpoint + 'backend/translation', {
            method: translationId ? 'put' : 'post',
            data: {
                key: key,
                de: de,
                en: en,
                translation: translationId,
                translationType: translationType
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(receiveAddEditTranslation(response.data));
                    dispatch(getTranslations(true));
                } else {
                    dispatch(receiveAddEditTranslationError(response.data));
                }
            }
        })
    }
}

export function sendAddEditTranslation() {
    return {
        type: TRANSLATION_SEND_ADD_EDIT_TRANSLATION
    }
}

export function receiveAddEditTranslation(data) {
    return {
        type: TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION,
        data
    }
}

export function receiveAddEditTranslationError(data) {
    return {
        type: TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR,
        data
    }
}